module.exports = require("@swa-ui/authentication");